import { useState, useEffect } from 'react'
import { useLocalStorage } from "@uidotdev/usehooks"

const useRecordStatuses = (props) => {
    const cacheMinutes = 60
    const [lastUpdated, setLastUpdated] = useLocalStorage('record_statuses_last_updated', 0)
    const [recordStatuses, setRecordStatuses] = useLocalStorage('record_statuses', [])
    
    useEffect(() => {
        if( recordStatuses.length === 0 ) {
            reload()
            return
        }
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        setLastUpdated(Date.now())
        fetch('/v0/record_statuses', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                const statuses = json.results
                setRecordStatuses(statuses)
            })
            .catch(error => {
                console.log("RecordStatuses reload error", error)
            })
    }

    return {
        recordStatuses,
    }
}

export default useRecordStatuses
